import React, { ReactNode } from 'react'
import { InputLabel } from '@node-space/storybook-components/dist/FormElements'
import { Box, Icon, Tooltip } from '@node-space/ui-components'

export interface InputLabelTooltipProps {
  id: string
  labelText?: ReactNode
  tooltipHeader?: string
  tooltipText: ReactNode
}

export const InputLabelTooltip = ({
  id,
  labelText,
  tooltipHeader,
  tooltipText,
}: InputLabelTooltipProps) => {
  return (
    <InputLabel forId={id}>
      <Box tag="span" flex align="center" gapX={4}>
        {labelText}
        <Tooltip
          header={tooltipHeader}
          bodyContent={tooltipText}
          type="complex"
          data-testid={`tooltip-${id}`}
        >
          <Box className="cursor-pointer">
            <Icon name="Info" />
          </Box>
        </Tooltip>
      </Box>
    </InputLabel>
  )
}
